import styled from 'styled-components';
import { Typography } from '../../global/theme';

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  border-radius: 8px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  overflow: hidden;
`;

export const ViewItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--background-tertiary);
  border-bottom: 0.5px solid var(--border-primary);
  color: var(--text-secondary);
  gap: 20px;
  padding: 8px 16px;
  cursor: pointer;
  :last-child {
    border-bottom: none;
  }
  .icon {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    &:hover {
      background: var(--background-muted);
    }
  }
  :hover {
    background: var(--neutral-secondary);
  }
`;

export const UserName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 200px;
  ${Typography.body_md_medium}
  p {
    color: var(--text-primary);
    margin: 0;
  }
  span {
    color: var(--text-secondary);
    margin: 0;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  .invoice-more-icon {
    font-size: 22px;
    cursor: pointer;
    color: var(--text-secondary);
    padding: 4px;
    border-radius: 4px;
    transition: background 0.2s;
    &:hover {
      background: var(--background-muted);
    }
  }
`;
export const BlankDiv = styled.div`
  width: 32px;
  height: 1px;
`;

export const AvatarsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
`;

export const AvatarWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--background-primary);
  background: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
  &:first-child {
    margin-left: 0;
  }
`;

export const PlusAvatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--text-secondary);
  color: var(--text-white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border: 2px solid var(--background-primary);
  margin-left: -8px;
`;
